import { render, staticRenderFns } from "./payResource.vue?vue&type=template&id=b96e3ae4&scoped=true"
import script from "./payResource.vue?vue&type=script&lang=js"
export * from "./payResource.vue?vue&type=script&lang=js"
import style0 from "./payResource.vue?vue&type=style&index=0&id=b96e3ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96e3ae4",
  null
  
)

export default component.exports